import { GuideOrderThemeSizeConfig } from './types';

const large: GuideOrderThemeSizeConfig = {
  guideOrder: {},
};

export default large;
